import { Button, Drawer, Inline, t } from '@kanbios/ui';
import { clockTime } from '../../lib/format';
import { EnrolmentProgress, failedServers, useEnrolmentJob } from '../../components/enrolment/EnrolmentProgress';

/**
 * An enrolment opened from Réglages › Accès aux serveurs: its follow-up in a
 * Drawer; « Relancer l'enrôlement » goes back to the import wizard.
 */
export function EnrolmentDrawer({ jobId, onClose, onRetry, canRetry }: { jobId: string | null; onClose: () => void; onRetry: (failed: string[]) => void; canRetry: boolean }) {
  const job = useEnrolmentJob(jobId);
  const data = job.data;
  const failed = failedServers(data);
  return (
    <Drawer
      open={Boolean(jobId)}
      onClose={onClose}
      eyebrow={t('settings.enrolment.job.eyebrow')}
      title={t('settings.enrolment.job.title', { n: data?.servers.length ?? 0 })}
      subtitle={data ? t('settings.enrolment.job.subtitle', { at: clockTime(data.createdAt), job: data.jobId }) : undefined}
      size="xl"
      footer={
        <Inline gap={8}>
          <Button variant="secondary" onClick={onClose}>{t('settings.enrolment.close')}</Button>
          {canRetry && data && data.status !== 'running' && data.status !== 'queued' && failed.length > 0 && (
            <Button icon="replay" onClick={() => onRetry(failed)}>{t('settings.enrolment.retry')}</Button>
          )}
        </Inline>
      }
    >
      <EnrolmentProgress job={data} loading={job.isPending} />
    </Drawer>
  );
}
